<template>
  <div class="p-4">
    <AgencySubscriptionForm v-if="subscription" :form-data="subscription" @close="goBack" @created="onSaved" />
  </div>
</template>

<script>
import AgencySubscriptionForm from './AgencySubscriptionForm.vue';
export default {
  name: 'AgencySubscriptionEdit',
  components: { AgencySubscriptionForm },
  data() {
    return {
      subscription: null,
      loading: true,
    };
  },
  created() {
    const id = this.$route.params.id;
    this.$store.dispatch('agency/fetchSubscriptionById', id)
      .then(data => {
        this.subscription = data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'agency.business-subscriptions' });
    },
    onSaved() {
      this.$router.push({ name: 'agency.business-subscriptions' });
    }
  }
};
</script>

